export default "__VITE_ASSET__6b3235aa__"